package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_05_23_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have traveled deep beneath the Gideon Forest and engaged the Drow adventurers that Lalia warned them about. These adversaries all have the ability to turn into smoke and travel a significant distance as a bonus action (Misty Step).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In the back on the enemy side are:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""🏹 Hotari (Rogue)
🧙🏿‍♀️ Parvir (Wizard)
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In the middle of battle are:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""⚔️ Vargas (the leader)
🧪 Ramadath (Cleric or Bard)
🌟 Tressa (Paladin)
🗡️ Delia (Barbarian)
---
😾 Bigglesworth
🦸‍♀️ Caper
🩹 Falorn
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In the back on the hero side are:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""🐜 Annette (left)
🧚‍♂️ Tuesday (right)
🫥 Elrovir (right)
🧙‍♂️ Dirk (far back)
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Hotari and Parvir attack the heroes from a distance but successfully hide or take cover after each attack. Ramadath tries to Hold Person and cast heals several times but largely fails or is Counter-Spelled. Tressa taunts Caper and smites her. Tuesday casts Greater Invisibility on himself and Elrovir; Elrovir doesn’t do anything useful during the battle.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Delia and Hotari focus on Dirk, nearly killing him. Bigglesworth and Falorn rush to his aid. Vargas makes an opportunity attack with his powerful black blade with red runes (a Vorpal sword); while it makes a “snicker snack” sound, Bigglesworth manages to keep his head. Bigglesworth and Falorn save Dirk, but Falorn falls to a Fireball.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth and Falorn’s exit from midfield provide an opening for the casters to fireball Vargas, Ramadath, and Tressa. Vargas falls but Tressa uses her Lay On Hands to bring him back.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes shift strategies. Tuesday drops his Greater Invisibility and Polymorphs Caper and Bigglesworth into Tyrannosaurus Rexes. Dirk sculpts a powerful whirlwind around Caper-Rex, which sucks up Vargas and Tressa.")
    }
}
